var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"icon":_vm.icon,"label":_vm.label,"to":_vm.to,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }